<template>
  <div class="d-flex flex-column" style="min-height: 100vh">
    <!-- content -->
    <div style="flex: 1">
      <!-- logo -->
      <logo_display></logo_display>
      <!-- logo -->

      <!-- heading -->
      <page_banner page_title="最新消息" />
      <!-- heading -->

      <b-container fluid class="mt-5">
        <!-- category -->

        <b-container class="mb-3 mt-3">
          <b-button
            class="category_button mx-2 my-2 font-weight-bold text"
            :active="category_tab == 'all'"
            @click="change_category('all')"
            >全部</b-button
          >
          <span v-for="(category, index) in categorys" :key="index">
            <b-button
              class="category_button mx-2 my-2 font-weight-bold text"
              :active="category_tab == category"
              @click="change_category(category.category_title)"
              >{{ category.category_title }}</b-button
            >
          </span>
        </b-container>
        <!-- <b-container class="mb-3 mt-3">
          <b-nav>
            <b-nav-item
              class="category_button"
              :active="category_tab == 'all'"
              @click="change_category('all')"
              >全部</b-nav-item
            >
            <span v-for="(category, index) in categorys" :key="index">
              <b-nav-item
                class="category_button"
                :active="category_tab == category"
                @click="change_category(category.category_title)"
                >{{ category.category_title }}</b-nav-item
              >
            </span>
          </b-nav>
        </b-container> -->
        <!-- category -->

        <!-- pined notice -->
        <b-container
          v-if="pin_notice_items.length > 0 && category_tab == 'all'"
        >
          <b-table :items="pin_notice_items" :fields="pin_notice_fields">
            <template #cell(title)="data">
              <router-link
                :to="{
                  name: 'notice_display',
                  params: { id: data.item.id },
                  query: { title: data.item.title, content: data.item.content },
                }"
              >
                {{ data.item.title }}
              </router-link>
            </template>

            <template #cell(update_at)="data">
              <span style="white-space: nowrap">
                <span class="px-3">
                  <b-button
                    class="category-display mx-2 my-2 font-weight-bold text"
                    disabled
                  >
                    {{ data.item.category }}
                  </b-button>
                </span>
                <span style="white-space: nowrap">
                  {{ data.item.update_at }}
                </span>
              </span>
            </template>
          </b-table></b-container
        >
        <!-- pined notice -->

        <!-- notice -->
        <b-container>
          <b-table
            :items="filted_notice_items"
            :fields="notice_fields"
            :per-page="per_page"
            :current-page="current_page"
            hover
          >
            <template #cell(title)="data">
              <router-link
                :to="{
                  name: 'notice_display',
                  params: { id: data.item.id },
                }"
                style="display: block"
              >
                {{ data.item.title }}
              </router-link>
            </template>

            <template #cell(update_at)="data">
              <span style="white-space: nowrap">
                <span class="px-3">
                  <b-button
                    class="category-display mx-2 my-2 font-weight-bold text"
                    disabled
                  >
                    {{ data.item.category }}
                  </b-button>
                </span>
                <span style="white-space: nowrap">
                  {{ data.item.update_at }}
                </span>
              </span>
            </template>
          </b-table>

          <b-pagination
            v-model="current_page"
            :total-rows="notice_items.length"
            :per-page="per_page"
            align="center"
          ></b-pagination>
        </b-container>
        <!-- notice -->
      </b-container>
    </div>
    <!-- content -->
  </div>
</template>

<script setup>
import api from "@/api/index.js";
import page_banner from "./page_banner.vue";
import logo_display from "./logo_display.vue";
import { computed, onMounted, ref } from "vue";
const pin_notice_fields = ref([
  {
    key: "title",
    label: "重要消息",
    thClass: "text-left",
    tdClass: "text-left",
  },
  {
    key: "update_at",
    label: "更新時間",
    thClass: "text-right",
    tdClass: "text-right",
  },
]);
const notice_fields = ref([
  {
    key: "title",
    label: "最新消息",
    thClass: "text-left",
    tdClass: "text-left",
  },
  {
    key: "update_at",
    label: "更新時間",
    thClass: "text-right",
    tdClass: "text-right",
  },
]);
const pin_notice_items = ref([]);
const notice_items = ref([]);
const categorys = ref([]);
const category_tab = ref("all");
const current_page = ref(1);
const per_page = ref(10);

const change_category = (tab_name) => (category_tab.value = tab_name);
const filted_notice_items = computed(() => {
  if (category_tab.value == "all") {
    return notice_items.value;
  } else {
    let items = [];
    for (let notice of notice_items.value) {
      if (notice.category == category_tab.value) {
        items.push(notice);
      }
    }
    return items;
  }
});

onMounted(async () => {
  try {
    let response = await api.get("/api/get_shop_notices");
    let category_list = [];
    for (let notice of response.data) {
      category_list.push({
        category_title: notice.category_title,
        category_priority: notice.category_priority,
      });

      if (notice.pin) {
        pin_notice_items.value.push({
          id: notice.id,
          title: notice.title,
          category: notice.category_title,
          update_at: notice.publish_time,
        });
      }
      notice_items.value.push({
        id: notice.id,
        title: notice.title,
        category: notice.category_title,
        update_at: notice.publish_time,
      });
    }
    let unique_category_map = new Map();
    category_list.forEach((item) => {
      unique_category_map.set(item.category_title, item);
    });
    let unique_category = Array.from(unique_category_map.values());

    let unsort_category = [...unique_category];
    categorys.value.push(
      ...unsort_category.sort(
        (a, b) => +a.category_priority - +b.category_priority
      )
    );
  } catch (err) {
    console.log(err);
  }
});
</script>

<style scoped>
.category_button {
  background-color: #ffc600;
  color: black;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  width: auto;
  display: inline-block;
}
.category_button:hover {
  background-color: #ffe4a3;
  color: #ffffff;
}
.category_button.active {
  background-color: #ffc600 !important;
  color: #ffffff !important;
  box-shadow: none !important;
  outline: none !important;
}
.category_button:focus {
  background-color: #ffc600 !important;
  color: #ffffff !important;
  box-shadow: none !important;
  outline: none !important;
}

.category-display:disabled {
  background-color: #ffc600 !important;
  border: none !important;
  color: black !important;
  opacity: 1 !important;
}

@media screen and (max-width: 768px) {
  .category-display:disabled {
    padding: 4px 8px;
    font-size: 12px;
    width: auto;
  }
}
/* .category-display:disabled {
  border: 2px solid gray;
  color: black;
  background-color: transparent;
  padding: 8px 15px;
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  .category-display:disabled {
    padding: 4px 8px;
    font-size: 12px;
    width: auto;
  }
} */

a {
  color: black;
}
a:hover {
  color: black;
  text-decoration: underline;
}

/* .nav-item .nav-link {
  position: relative;
  color: gray;
}

.nav-item .nav-link.active {
  color: black;
}

.nav-item .nav-link::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background-color: black;
  transition: width 0.5s ease;
}

.nav-item .nav-link:not(.active):hover::after {
  width: 100%;
}

.nav-item .nav-link.active::after {
  width: 100%;
  transition: none;
} */
</style>
